// src/steps/StepDates.tsx
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import React from 'react';
import { DateRange, RangeKeyDict } from 'react-date-range';
import { es } from 'date-fns/locale';
import { differenceInCalendarDays, addDays, eachDayOfInterval } from 'date-fns';

import { ModoTransporte } from '../api/api';
import logoConcello from '../assets/logo-concello-ribeira.png';
import styles from '../styles/stepDates.module.css';

interface Props {
  dateRange: { start: Date; end: Date };
  setDateRange: (dr: { start: Date; end: Date }) => void;
  modoTransporte: ModoTransporte;
  setModoTransporte: (modo: ModoTransporte) => void;
  onNext: (days: number[]) => void;
}

const MAX_DAYS = 7;

const transportOptions: Array<{ value: ModoTransporte; label: string; }> = [
  { value: 'andando', label: 'A pie'},
  { value: 'bici', label: 'En bici'},
  { value: 'coche', label: 'En coche'},
];

const clampEnd = (start: Date, end: Date) =>
  differenceInCalendarDays(end, start) > MAX_DAYS
    ? addDays(start, MAX_DAYS)
    : end;

const StepDates: React.FC<Props> = ({
  dateRange,
  setDateRange,
  modoTransporte,
  setModoTransporte,
  onNext,
}) => {
  const handleChange = (r: RangeKeyDict) => {
    const start = r.selection.startDate!;
    const end = clampEnd(start, r.selection.endDate!);
    setDateRange({ start, end });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const days = eachDayOfInterval({ start: dateRange.start, end: dateRange.end }).map(
      (_d, i) => i + 1,
    );
    onNext(days);
  };

  return (
    <div className={styles.card}>
      <img
        src={logoConcello}
        alt="Concello de Ribeira"
        className={styles.cornerLogo}
      />
      <form className={styles.form} onSubmit={handleSubmit}>
        <h2 className={styles.sectionTitle}>Selecciona fecha de llegada y salida</h2>

        <fieldset className={styles.transportSection}>
          <legend>¿cómo harás la ruta?</legend>
          <div className={styles.transportOptions}>
            {transportOptions.map((option) => (
              <label
                key={option.value}
                className={`${styles.transportOption} ${
                  modoTransporte === option.value ? styles.transportOptionActive : ''
                }`}
              >
                <input
                  type="radio"
                  name="modoTransporte"
                  value={option.value}
                  checked={modoTransporte === option.value}
                  onChange={() => setModoTransporte(option.value)}
                />
                <span>{option.label}</span>
                
              </label>
            ))}
          </div>
        </fieldset>

        <div className={styles.dateSection}>
          <DateRange
            ranges={[{ startDate: dateRange.start, endDate: dateRange.end, key: 'selection' }]}
            onChange={handleChange}
            moveRangeOnFirstSelection={false}
            months={1}
            direction="horizontal"
            rangeColors={['#0070C8', '#164F8F']}
            locale={es}
            dateDisplayFormat="dd/MM/yyyy"
          />
        </div>

        <div className={styles.buttons}>
          <button type="submit" className={styles.nextButton}>
            Continuar
          </button>
        </div>
      </form>
    </div>
  );
};

export default StepDates;
